









































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component({})
export default class AppRadio extends Vue {
  @Prop() readonly value!: number;
  @Prop() readonly options!: string[];
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ type: String }) readonly hint!: string;

  activeIndex = 0;

  mounted () {
    this.activeIndex = this.value
  }

  @Emit('input')
  switchValue (index: number) {
    this.activeIndex = index
    return index
  }

  slot (index: number) {
    return 'option_' + index
  }
}
